import React from 'react'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import Spinner from 'srcReact/components/common2/Spinner'

function AnimatedButton({ isDone, loading, beforeText, afterText, onClick }) {
  return (
    <button disabled={loading} className={styles.postButtonWrapper} onClick={onClick}>
      <div className={`${styles.postButton} ${isDone && styles.postButtonGreen}`}>
        <div className={`${styles.roundButton} ${isDone && styles.roundBtnAnime}`}>
          <Icon name='send-copy' />
        </div>
        <p className={`${styles.buttonText} ${isDone && styles.postedButtonText}`}>
          {loading ? <Spinner /> : isDone ? afterText : beforeText}
        </p>
      </div>
    </button>
  )
}

export default AnimatedButton
